import { Phone, MessageCircle, Map } from "lucide-react";
import { BRAND } from "@/mock";

const QUICK_LINKS = [
  { label: "Rooms", id: "rooms" },
  { label: "Facilities", id: "facilities" },
  { label: "Location", id: "location" },
  { label: "Contact", id: "contact" },
];

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const Footer = () => {
  return (
    <footer className="bg-[#1A1A1A] pt-14 pb-8 px-5 md:px-10 border-t border-[#C8A97E]/15" data-testid="main-footer">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-[2fr_1fr_1fr] gap-10 pb-10 border-b border-white/10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-full bg-[#C8A97E] flex items-center justify-center text-[#1A1A1A] font-serif text-2xl font-bold">
                H
              </div>
              <div>
                <div className="font-serif text-[22px] font-semibold text-white leading-tight">
                  Hitha Residency
                </div>
                <div className="text-[10px] tracking-[0.22em] uppercase text-[#C8A97E]">
                  Service Apartment · Bangalore
                </div>
              </div>
            </div>
            <p className="text-[13px] text-white/45 leading-[1.75] max-w-md">
              Fully furnished service apartments on Tumkur Road, Bangalore. Daily &amp; Monthly rental.
              1 km from Chikkabidarakallu Metro.
            </p>
          </div>

          <div>
            <div className="text-[10px] tracking-[0.22em] uppercase text-[#C8A97E] font-semibold mb-4">
              Quick Links
            </div>
            <ul className="space-y-2.5">
              {QUICK_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    onClick={() => scrollToId(l.id)}
                    className="text-[13px] text-white/55 hover:text-[#C8A97E] transition-colors"
                    data-testid={`footer-link-${l.id}`}
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-[10px] tracking-[0.22em] uppercase text-[#C8A97E] font-semibold mb-4">
              Contact
            </div>
            <ul className="space-y-2.5">
              <li>
                <a
                  href={`tel:${BRAND.phone}`}
                  className="text-[13px] text-white/55 hover:text-[#C8A97E] inline-flex items-center gap-2 transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone className="w-3.5 h-3.5" /> {BRAND.phone}
                </a>
              </li>
              <li>
                <a
                  href={`https://wa.me/${BRAND.whatsapp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[13px] text-white/55 hover:text-[#C8A97E] inline-flex items-center gap-2 transition-colors"
                  data-testid="footer-whatsapp"
                >
                  <MessageCircle className="w-3.5 h-3.5" /> WhatsApp
                </a>
              </li>
              <li>
                <a
                  href={`https://maps.google.com/?q=${BRAND.mapsQuery}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[13px] text-white/55 hover:text-[#C8A97E] inline-flex items-center gap-2 transition-colors"
                  data-testid="footer-maps"
                >
                  <Map className="w-3.5 h-3.5" /> Google Maps
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-3 pt-6">
          <div className="text-[11px] text-white/35 text-center md:text-left">
            © 2026 Hitha Residency · No.11 Vinayaka Layout, Tumkur Road, Bangalore 560073
          </div>
          <div className="text-[13px] font-serif italic text-[#C8A97E]/60">
            Comfort · Convenience · Luxury
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
